<script setup>
import { defineProps } from "vue";

defineProps({
  icon: {
    type: String,
    required: true,
  },

  description: {
    type: String,
    default: "",
  },

  small: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <div class="chat-empty">
    <div
      class="chat-empty__circle"
      :class="{ 'chat-empty__circle_small': small }"
    >
      <i :class="icon" />
    </div>
    <p v-if="description">{{ description }}</p>
  </div>
</template>

<style scoped lang="scss">
.chat-empty {
  display: flex;
  flex-direction: column;
  align-items: center;

  &__circle {
    width: 72px;
    height: 72px;
    background: $background-light-accent;
    display: grid;
    place-items: center;
    border-radius: 50%;
    margin-bottom: $base-space * 6;

    @media (max-width: 1023px) {
      margin-bottom: $base-space * 8;
      width: 96px;
      height: 96px;
    }

    > i {
      width: 40px;
      height: 40px;
      background: $text-accent;

      @media (max-width: 1023px) {
        width: 48px;
        height: 48px;
      }
    }

    &_small {
      @media (max-width: 1023px) {
        width: 72px;
        height: 72px;
      }
    }
  }

  > h2 {
    color: $text-primary;
    margin-bottom: $base-space * 3;
    text-align: center;

    @include h-3();

    @media (max-width: 1023px) {
      @include h-2();
    }
  }

  > p {
    color: $text-third;
    text-align: center;

    @include s-text();
    @media (max-width: 1023px) {
      @include m-text();
    }
  }
}
</style>
